/* eslint-disable no-restricted-syntax */
export default {
  /**
   *
   * @param caseManager Object
   * @param short Boolean
   * @returns {string}
   */
  formatName(caseManager, short) {
    const cm = caseManager;
    if (short !== null && typeof short !== 'undefined') {
      if (short) {
        return `${cm.name} ${cm.firstName}`;
      }
    }
    return `${cm.name} ${cm.firstName}`;
  },
};



// WEBPACK FOOTER //
// ./src/services/CaseManagerService.js